import { IsString, IsBoolean, IsOptional, IsArray, ValidateNested, IsEnum } from 'class-validator';
import { FieldOptionDto } from './field-option.dto';
import { FieldDto } from './field-info.dto';
import { FieldOptionInterface } from '../../interfaces';
import { Type } from 'class-transformer';

export class DefaultFieldInfoDto extends FieldDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => FieldOptionDto)
	@IsOptional()
	options?: Array<FieldOptionInterface>;
}
